import { AxiosError } from "axios";
import { useState } from "react";
import {useLocation, useNavigate} from 'react-router'
import { ROUTES, AUTHED_ROUTES, PUBLIC_ROUTES } from "../../routes/constants";
import { useAppDispatch } from "../store";
import { unsetAuth } from "../store/reducers/user-reducer";
import api from "../http";

export default function useFetch<Args extends any[], T>(
    callback: (...args: Args) => Promise<T | undefined>, callbackError?: () => any,
): [(...args: Args) => Promise<T | undefined>, boolean, string, any] {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [error, setError] = useState<string>('')
    const [errors, setErrors] = useState<any>([])
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useAppDispatch()

    const fetching = async (...args: Args): Promise<T | undefined> => {
        try {
            setError('')
            setErrors([])
            setIsLoading(true)
            const data = await callback(...args)
            return data
        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(location.pathname)
                if (error.config?.url === `/user/refresh`) {
                    localStorage.removeItem('accessToken')
                    await api.get(`/user/logout`, { withCredentials: true })
                    dispatch(unsetAuth())
                    if (Object.values(AUTHED_ROUTES).find(route => route === location.pathname)) {
                        navigate(PUBLIC_ROUTES.LOGIN_ROUTE)
                    }
                }
                setError(error.response?.data?.message || '')
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
                if(callbackError) callbackError()
            } else if (error instanceof Error) {
                setError(error.message)
                if(callbackError) callbackError()
            }
            else {
                setError(error.message)
                if(callbackError) callbackError()
            }

        } finally {
            setIsLoading(false)
        }
    }

    return [fetching, isLoading, error, errors]
}